import * as Sentry from '@sentry/react'
import {
  BrowserTracing,
  defaultStackParser,
  makeFetchTransport,
  Replay,
} from '@sentry/react'

import { APP_RELEASE_TAG, APP_SENTRY_SERVICE, SENTRY_ENV } from '..'

import { getHeaderSentry } from './headerSentry'

const appSentryBrowserOptions = {
  debug: SENTRY_ENV !== 'production',
  dsn: APP_SENTRY_SERVICE,
  environment: SENTRY_ENV,
  release:
    window.SENTRY_RELEASE?.id === APP_RELEASE_TAG
      ? window.SENTRY_RELEASE?.id
      : APP_RELEASE_TAG,
  integrations: [
    // Dedupe prevents some duplicate events from being sent - this messes with capturing events that are caught by both the header and the running application (Sentry drops the events) - so disable it
    ...Sentry.defaultIntegrations.filter(
      (integration) => integration.name !== 'Dedupe'
    ),
    new BrowserTracing(),
    new Replay({ maskAllText: false, blockAllMedia: false }),
  ],
  // Keep all traces and send them all to Sentry - will generate a substantial amount of data
  tracesSampleRate: 1.0,
  // Keep all replays that are recorded in general, whether from an error or not and send them all to Sentry - will generate a substantial amount of data
  replaysSessionSampleRate: 0.1,
  // Keep all replays that are recorded when an error occurs and send them all to Sentry
  replaysOnErrorSampleRate: 1.0,
  beforeSend (event: Sentry.Event) {
    try {
      // Try and get info about the event so it can be sent to the correct project.

      if (
        event.exception?.values?.some((value) => {
          if (value?.stacktrace?.frames) {
            if (
              value.stacktrace.frames[
                value.stacktrace.frames.length - 1
              ].filename?.includes('hb-header-app')
            ) {
              return true
            }
          }

          return false
        })
      ) {
        // Tag the event so we can see where it came from even if the below doesn't work for some reason

        const taggedEvent = event

        taggedEvent.tags = {
          application: 'hb-header-app',
          'event-created-in-application': 'hb-event-manager',
        }

        if (getHeaderSentry()[0] != null) {
          // Use the client for the header to capture the event as it occured in the header - and use the release for the header so the event can be tracked against it

          const [headerSentry, headerAppRelease] = getHeaderSentry()

          taggedEvent.release = headerAppRelease

          // Send the event to Sentry for the header
          headerSentry?.captureEvent(event)
          // Don't send the event to Sentry twice - it has already been sent via the header client
          return null
        }
        // Something went wrong but we still want to capture the event somewhere - so capture it via the application client
        return taggedEvent
      }
      return event
    } catch (e) {
      // Attempt to report the exception that occured whilst processing the current event, to Sentry
      Sentry.captureException(e, {
        extra: { ERROR_CONTEXT: 'SENTRY_HUB_ERROR_EVENT_MANAGER' },
      })

      // The event failed to process but send it to Sentry so it can at least be recorded
      return event
    }
  },
  transport: makeFetchTransport,
  stackParser: defaultStackParser,
}

export default appSentryBrowserOptions
